/** 學生課程內頁共用:側欄渲染、課程資料載入、格式工具。
 *  自 public/js/course-common.js 移植。
 */
import { request } from './api';
import { init as initSidebar, type SidebarActive } from './sidebar';
import type { Course, Me, StudentSummary } from './types';

export function qs(name: string): string | null {
  return new URLSearchParams(window.location.search).get(name);
}

export function fmtSize(bytes: number): string {
  if (bytes >= 1048576) return `${(bytes / 1048576).toFixed(1)}MB`;
  if (bytes >= 1024) return `${Math.round(bytes / 1024)}KB`;
  return `${bytes}B`;
}

const pad = (n: number) => String(n).padStart(2, '0');

export function fmtDate(v: string | number | Date | null | undefined): string {
  if (!v) return '';
  const d = new Date(v);
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
}

export function fmtDateTime(v: string | number | Date | null | undefined): string {
  if (!v) return '';
  const d = new Date(v);
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export interface CoursePageResult {
  me: Me;
  summary: StudentSummary | null;
  course: Course | null;
  courseId: string | null;
}

/** 初始化課程頁:登入檢查、載入課程、渲染主側欄(當前課程展開第三層子選單) */
export async function initPage(opts: { active: SidebarActive }): Promise<CoursePageResult> {
  const courseId = qs('id') ?? qs('courseId');
  const [sb, course] = await Promise.all([
    initSidebar({ courseId, active: opts.active }),
    courseId ? request<Course>(`/api/courses/${courseId}`) : Promise.resolve(null),
  ]);
  return { me: sb.me, summary: sb.summary, course, courseId };
}
